import React, { useContext} from "react";
import { Context } from "../../context/contextapi";

function PaginationUI({ page, handleNext, handlePrev }) {
  const { hasMore } = useContext(Context);
  
  

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {/* Previous Button */}
      <button
        onClick={handlePrev}
        style={{
          padding: "0px 9px",
          marginRight: "10px",
          height: "30px",
          borderRadius: "8px",
          border: "1px solid #1c1c1c",
          cursor: "pointer",
        }}
        disabled={page === 1}
      >
        Prev
      </button>

      {/* Current Page Box */}
      <div
        style={{
          width: "30px",
          height: "30px",
          border: "1px solid #1c1c1c",
          padding: "2px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: "10px",
          borderRadius: "10px",
        }}
      >
        {page}
      </div>

      {/* Next Button */}
      <button
        onClick={handleNext}
        style={{
          padding: "0px 9px",
          height: "30px",
          marginLeft: "10px",
          borderRadius: "8px",
          border: "1px solid #1c1c1c",
          cursor: "pointer",
        }}
        disabled={hasMore ? false : true} 
      >
        Next
      </button>
    </div>
  );
}

export default PaginationUI;
